import { render, staticRenderFns } from "./PilihKandidat.vue?vue&type=template&id=677d8a7d&scoped=true&lang=html&"
import script from "./PilihKandidat.vue?vue&type=script&lang=js&"
export * from "./PilihKandidat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677d8a7d",
  null
  
)

export default component.exports